import SuccessIcon from 'components/Icons/SuccessIcon';
import Loader from 'components/Loader';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ProcessingMobile = () => {
  const { refresh, loading } = useHistoryBatch();

  const { t } = useTranslation(['history', 'beneficiaries']);

  return (
    <div className="success-import-mobile">
      <p>{t('details')}</p>
      <SuccessIcon />
      <span>{t('follow_up')}</span>
      <span>{t('follow_up_text')}</span>
      <div className="button-container">
        <button type="button" className="reimport-button" onClick={refresh}>
          {loading ? <Loader small /> : t('refresh_page')}
        </button>
      </div>
    </div>
  );
};
